module.exports = __webpack_public_path__ + "static_portal/img/logo.78675542.png";